import { ModalProviderProps } from '@/shared/contexts';

export const componentDictionary: ModalProviderProps['components'] = {};
